<template>
  <div class="upload-container">
    <el-button
      :style="{ background: color, borderColor: color }"
      icon="el-icon-upload"
      size="mini"
      type="primary"
      @click="dialogVisible = true"
    >
      上传图片
    </el-button>
    <el-dialog :visible.sync="dialogVisible">
      <el-upload
        :multiple="true"
        :file-list="fileList"
        name="imgFile"
        :show-file-list="true"
        accept="image/*"
        :before-upload="beforeUpload"
        :http-request="customRequest"
        :on-success="handleSuccess"
        :on-remove="handleRemove"
        class="editor-slide-upload"
        action="#"
        list-type="picture-card"
      >
        <el-button size="small" type="primary">
          点击上传
        </el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="handleSubmit">
        确认
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getCosConfig, getPresignDownloadUrl, uploadImageFile } from '@/api/upload'
import Cos from 'cos-js-sdk-v5'
import {uploadUtil} from "@/utils/uploadCommon";

export default {
  name: 'EditorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff'
    }
  },
  data() {
    return {
      // uploadImageFile,
      dialogVisible: false,
      listObj: {},
      fileList: []
    }
  },
  created() {
    getCosConfig().then(res => {
      this.config = res.data
    })
    this.cosInstance = new Cos({
      Protocol: 'https:',
      getAuthorization: (options, callback) => {
        getCosConfig().then(res => {
          this.config = res.data
          const data = res.data
          callback({
            TmpSecretId: data.secretId,
            TmpSecretKey: data.secretKey,
            XCosSecurityToken: data.token,
            StartTime: data.StartTime,
            ExpiredTime: data.expiredTime // 时间戳，单位秒，如：1580000900
          })
        })
      }
    })
  },
  methods: {
    // checkAllSuccess() {
    //   return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess)
    // },

    //上传前处理
    beforeUpload(file) {
      return uploadUtil(file)
    },

    handleSubmit() {
      // const arr = Object.keys(this.listObj).map(v => this.listObj[v])
      // if (!this.checkAllSuccess()) {
      //   this.$message('请等待所有图片上传成功。如果有网络问题，请刷新页面并重新上传')
      //   return
      // }
      this.$emit('successCBK', this.fileList)
      this.listObj = {}
      this.fileList = []
      this.dialogVisible = false
    },
    customRequest(res) {
      this.disable = true
      const formData = new FormData()
      formData.append("imgFile",res.file);
      uploadImageFile(formData).then(res=>{
        if (res.code ==200){
          console.log(res.data,"1111")
          getPresignDownloadUrl(res.data).then(result => {
            console.log(result.data,"dsadas")
            this.listObj = result.data
            this.fileList[this.fileList.length] = { url: result.data }
            this.handleSuccess(
              {
                data: {
                  cover_oss_url: result.data
                }
              },
              res.file
            )
          })
        } else {
          this.$message.error('上传失败')
        }

      })
    },
    handleSuccess(response, file) {
      const uid = file.uid
      const objKeyArr = Object.keys(this.listObj)
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url = response.data.cover_oss_url
          this.listObj[objKeyArr[i]].hasSuccess = true
          return
        }
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    }
  }
}
</script>

<style lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  /deep/ .el-upload--picture-card {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tinymce/components/EditorImage.vue